import { createAction, createApiAction } from 'store';
import * as types from './ActionTypes';

export const postSurveyScheduling = createApiAction(
	types.POST_SURVEY_SCHEDULING,
);

export const updateSurveyScheduling = createApiAction(
	types.UPDATE_SURVEY_SCHEDULING,
);

export interface ISurveyDataAction {
	templateId: string;
	clientId?: string;
}

export const getSurveyData = createApiAction<ISurveyDataAction>(
	types.GET_SURVEY_DATA,
);

export const getPlannedSurveyData = createApiAction<{ surveyId: string }>(
	types.GET_PLANNED_SURVEY_DATA,
);

export const resetPlannedSurveyData = createAction(types.RESET_PLANNED_SURVEY);

export const setSurveyData = createAction(types.SET_SURVEY_DATA);

export const getSurveyRoles = createApiAction(types.GET_SURVEY_ROLES);
export const postSurveyRole = createApiAction(types.POST_SURVEY_ROLE);
export const deleteSurveyRole = createApiAction(types.DELETE_SURVEY_ROLE);
export const editSurveyRole = createApiAction(types.EDIT_SURVEY_ROLE);
export const resetRolesError = createAction(types.RESET_ROLES_ERROR);

export const getCompanyClients = createApiAction(types.GET_COMPANY_CLIENTS);

export const getCompanyOffices = createApiAction<{ clientId: string }>(
	types.GET_COMPANY_OFFICES,
);
export const getSurveyLimits = createApiAction<{ clientId: string }>(
	types.GET_SURVEY_LIMITS,
);

export const getOfficesAndLimitsData = createApiAction<{ clientId: string }>(
	types.GET_OFFICES_AND_LIMITS_DATA,
);

export const resetSchedulingError = createAction(types.RESET_SCHEDULING_ERROR);
export const resetScheduling = createAction(types.RESET_SCHEDULING);
